const FullScreenReducers = (state = false, action) => {
  switch (action.type) {
    case "openFullScreen":
      return (state = true);
    case "closeFullScreen":
      return (state = false);
    default:
      return state;
  }
};
export default FullScreenReducers;
